import { getPalette } from 'owa-theme';
import ColorScheme from 'owa-color-utils/lib/ColorScheme';

/**
 * Gets the location icon background color based on the location type
 * @param placeType the place type, Unknown, public, private and room
 * @param colorScheme the color scheme of the calendar
 */
export default function getLocationCardIconBackgroundColor(
    placeType: string,
    colorScheme?: ColorScheme
): string {
    const palette = getPalette();
    if (placeType == 'Unknown') {
        return palette.neutralLight;
    }
    return colorScheme ? colorScheme.calPrimary : palette.themePrimary;
}
